import React, { useEffect } from 'react';
import MailSender from './MailSender';

const EmailTemplate = ({ closeModal }) => {
  return (
    <div className="w-[900px]  bg-white rounded-lg p-5">
      <MailSender closeModal={closeModal} />
    </div>
  );
};

export default EmailTemplate;
